import { base } from './en/base';
import { objects } from './en/objects';
import { projectPages } from './en/projects';
import { settings } from './en/settings';

/** English texts of the module, below its ID: `projects.nav.projects`. One file per area. */
export const en = { ...base, objects, projectPages, settings };
